import React from "react";
import { Row, Col } from "reactstrap";

const AdminFooter = () => {
  const authSession = JSON.parse(localStorage.getItem('auth'));

  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-xl-between">
        {/* <Col xl="12">
          <div className="copyright text-center text-xl-left">
          Copyright © {new Date().getFullYear()} <strong>{authSession?.merchantName}</strong> | All Rights Reserved.
          </div>
        </Col> */}
      </Row>
    </footer>
  );
}

export default AdminFooter;


